function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", {
  type: "text/css"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M511.995 914.711107c-49.870951 0-98.280904-9.77799-143.86286-29.060972-44.011957-18.614982-83.536918-45.249956-117.459885-79.183923-33.928967-33.925967-60.565941-73.446928-79.180922-117.454885-19.288981-45.590955-29.060972-93.989908-29.060972-143.868859 0-135.626868 74.096928-260.140746 193.380811-324.937683 20.23198-10.987989 45.542956-3.500997 56.535945 16.731984 10.993989 20.23098 3.502997 45.547956-16.733984 56.534944-92.40091 50.197951-149.806854 146.632857-149.806854 251.669755 0 157.803846 128.384875 286.188721 286.187721 286.18872S798.179721 702.945314 798.179721 545.142468c0-103.528899-56.182945-199.296805-146.630857-249.920756-20.08998-11.246989-27.263973-36.652964-16.012985-56.741945 11.241989-20.09198 36.652964-27.267973 56.736945-16.017984 56.387945 31.560969 103.749899 77.555924 136.975866 133.01387 34.219967 57.147944 52.319949 122.72888 52.319949 189.666815 0 49.878951-9.78399 98.277904-29.064972 143.868859-18.617982 44.007957-45.251956 83.535918-79.175922 117.454885-33.931967 33.933967-73.452928 60.568941-117.469885 79.187923-45.577955 19.278981-93.992908 29.056972-143.86286 29.056972z m0-398.266611c-25.318975 0-45.848955-20.52098-45.848955-45.844956V155.137848c0-25.320975 20.52898-45.849955 45.848955-45.849955s45.849955 20.52798 45.849955 45.849955v315.462692c0 25.322975-20.53098 45.843955-45.849955 45.843956z",
  fill: "#DA3429",
  "p-id": 5144
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "icon",
    height: 24,
    "p-id": 5143,
    style: {},
    t: 1481209278818,
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.f6053970.svg";
export { ForwardRef as ReactComponent };